import { FDBodyText } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * @deprecated Renamed for consistency. Please use BodyTextLarge from /FacetDesign/Components/Text instead.
 */
const BodyTextLarge = ({ value }) => {
  return <FDBodyText size="lg" value={value ?? ''} />;
};
BodyTextLarge.propTypes = { value: PropTypes.string.isRequired };

export default BodyTextLarge;
